import {isFlagOn} from './flags';

// The numeric `acceptable` shapes a field can carry, as the backend writes and
// judges them (InspectionResultService::collectCorrectiveData):
//   {type: 'range', value: 'min|max'} - both bounds, the bounds themselves pass
//   {type: 'min'|'max', value}        - one bound, the bound itself passes
//   `exclusive` on a one sided bound makes reaching it a violation already.
export const toNumber = value => {
  const text = String(value ?? '').trim();
  return text === '' ? NaN : Number(text);
};

export const parseAcceptable = acceptable => {
  const exclusive = isFlagOn(acceptable?.exclusive);

  if (acceptable?.type === 'range') {
    const parts = String(acceptable?.value ?? '').split('|');
    if (parts.length !== 2) {
      return null;
    }
    const [min, max] = parts.map(toNumber);
    return Number.isNaN(min) || Number.isNaN(max)
      ? null
      : {min, max, exclusive};
  }

  if (acceptable?.type === 'min' || acceptable?.type === 'max') {
    const limit = toNumber(acceptable?.value);
    if (Number.isNaN(limit)) {
      return null;
    }
    return acceptable.type === 'min'
      ? {min: limit, exclusive}
      : {max: limit, exclusive};
  }

  return null;
};

export const isOutsideAcceptable = (value, bounds) => {
  if (!bounds) {
    return false;
  }
  const {min, max, exclusive} = bounds;
  if (min !== undefined && (exclusive ? value <= min : value < min)) {
    return true;
  }
  return max !== undefined && (exclusive ? value >= max : value > max);
};

// How the bound reads in the warning: "34.6 - 36.6", "< -29", "≥ 40".
export const describeAcceptable = bounds => {
  if (!bounds) {
    return '';
  }
  const {min, max, exclusive} = bounds;
  if (min !== undefined && max !== undefined) {
    return `${min} - ${max}`;
  }
  if (max !== undefined) {
    return `${exclusive ? '<' : '≤'} ${max}`;
  }
  return `${exclusive ? '>' : '≥'} ${min}`;
};
